import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_LABORATORYPERSONNEL_LOAD,
    ACTION_LABORATORYPERSONNEL_LOAD_BY_ID,
    ACTION_LABORATORYPERSONNEL_LOAD_BY_LABORATORY_ID,

    ACTION_LABORATORYPERSONNEL_SAVE,

    ACTION_LABORATORYPERSONNEL_CREATE,

    ACTION_LABORATORYPERSONNEL_VALIDATE,

    ILaboratoryPersonnelsLoadAction,
    ILaboratoryPersonnelLoadByIdAction,
    ILaboratoryPersonnelLoadByLaboratoryIdAction,
    ILaboratoryPersonnelLoadFailureAction,
    ILaboratoryPersonnelLoadSuccessAction,

    ILaboratoryPersonnelSaveAction,
    ILaboratoryPersonnelSaveSuccessAction,
    ILaboratoryPersonnelSaveFailureAction,

    ILaboratoryPersonnelCreateAction,
    ILaboratoryPersonnelCreateSuccessAction,
    ILaboratoryPersonnelCreateFailureAction,

    ILaboratoryPersonnelValidateAction,
    ILaboratoryPersonnelValidateSuccessAction,
    ILaboratoryPersonnelValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/laboratoryPersonnels";
import { laboratoryPersonnelsApi } from "../services/laboratoryPersonnels";


export const
    getLaboratoryPersonnelsEpic = (action$): Observable<ILaboratoryPersonnelLoadSuccessAction | ILaboratoryPersonnelLoadFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYPERSONNEL_LOAD)
            .mergeMap((_action: ILaboratoryPersonnelsLoadAction) => {
                return laboratoryPersonnelsApi
                    .getLaboratoryPersonnels()
                    .map(response =>
                        LoadSuccess(response.laboratoryPersonnels, undefined, undefined, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getLaboratoryPersonnelByIdEpic = (action$): Observable<ILaboratoryPersonnelLoadSuccessAction | ILaboratoryPersonnelLoadFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYPERSONNEL_LOAD_BY_ID)
            .mergeMap((action: ILaboratoryPersonnelLoadByIdAction) => {
                return laboratoryPersonnelsApi
                    .getLaboratoryPersonnelById(action.id)
                    .map(response =>
                        LoadSuccess(response.laboratoryPersonnel, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getLaboratoryPersonnelByLaboratoryIdEpic = (action$): Observable<ILaboratoryPersonnelLoadSuccessAction | ILaboratoryPersonnelLoadFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYPERSONNEL_LOAD_BY_LABORATORY_ID)
            .mergeMap((action: ILaboratoryPersonnelLoadByLaboratoryIdAction) => {
                return laboratoryPersonnelsApi
                    .getLaboratoryPersonnelByLaboratoryId(action.laboratoryId)
                    .map(response =>
                        LoadSuccess(response.laboratoryPersonnel, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setLaboratoryPersonnelEpic = (action$): Observable<ILaboratoryPersonnelSaveSuccessAction | ILaboratoryPersonnelSaveFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYPERSONNEL_SAVE)
            .mergeMap((action: ILaboratoryPersonnelSaveAction) => {
                return laboratoryPersonnelsApi
                    .setLaboratoryPersonnel(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.laboratoryPersonnel, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createLaboratoryPersonnelEpic = (action$): Observable<ILaboratoryPersonnelCreateSuccessAction | ILaboratoryPersonnelCreateFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYPERSONNEL_CREATE)
            .mergeMap((action: ILaboratoryPersonnelCreateAction) => {
                return laboratoryPersonnelsApi
                    .createLaboratoryPersonnel(action.laboratoryId)
                    .map(response =>
                        CreateSuccess(response.laboratoryPersonnel, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateLaboratoryPersonnelEpic = (action$): Observable<ILaboratoryPersonnelValidateSuccessAction | ILaboratoryPersonnelValidateFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYPERSONNEL_VALIDATE)
            .mergeMap((action: ILaboratoryPersonnelValidateAction) => {
                return laboratoryPersonnelsApi
                    .validateLaboratoryPersonnel(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.laboratoryPersonnel, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }